module.exports = __webpack_public_path__ + "static/img/m_finance.344c00f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mine/m_finance.png
// module id = aeqe
// module chunks = 9